import { CurrencyEnum } from '../../lib/types/enums/common/currency.enum'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterCurrency(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getCenterCurrency.url, { id }))
    .get<{ currency: CurrencyEnum }>()
}
